/* globals console, localStorage, module, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    user = require('../models/user'),
    configuration = require('../utilities/configuration'),
    templates = require('../utilities/handlebars').templates,
    inChannel = BackboneRadio.channel('vaultInterface:in'),
    EOL = null;

module.exports = Marionette.View.extend({
    template: templates.contexts,
    tagName: 'div',
    attributes: {
        class: 'contexts row mt-2'
    },
    events: {
        'change input[type=radio]': 'onChangeRadio',
        'click button': 'onClickButton'
    },
    templateContext: function () {
        const o = {
                userName: localStorage.getItem('userName') || '',
                password: localStorage.getItem('password') || ''
            };
        o[user.isSignedIn() ? 'signedIn' : 'signedOut'] = true;
        o.userNameRoles = _.concat([o.userName], _.filter(['rts-org', 'rts-admin'], function (role) {
            return user.hasRole(role) ? role : undefined;
        })).join(', ');
        return o;
    },
    initialize: function () {
        this.listenTo(user, 'change:JWT', _.bind(function () {
            // console.log(model.changed);
            this.render();
        }, this));
    },
    onClickButton: function (event) {
        const userName = jQuery('input[name=userName]', this.$el).val(),
            password = jQuery('input[name=password]', this.$el).val();
        localStorage.setItem('userName', userName);
        localStorage.setItem('password', password);
        user[event.currentTarget.dataset.action](userName, password);
        return false;
    }
});
